/**
 * Scrolls an element to the top of its scroll container, tolerating a missing element or a
 * environment without `scrollIntoView` (jsdom does not implement it).
 */
export const scrollElementIntoView = (element: HTMLElement | null): void => {
    element?.scrollIntoView?.({ behavior: 'smooth', block: 'start' });
};
